import React, { useCallback } from 'react'

import styles from './Input.module.css'

const TextInput = ({
  type,
  value,
  onChange,
  placeholder,
  label,
  disabled,
  className,
  button,
  ...rest
}) => {
  const onKeyPressed = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        button && button.onClick()
      }
    },
    [button]
  )

  return (
    <div
      className={`${styles.container} ${className || styles.defaultContainer}`}
    >
      <input
        type={type || 'text'}
        className={button ? styles.inputWithButton : styles.input}
        value={value || ''}
        placeholder={placeholder || label}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={onKeyPressed}
        disabled={disabled}
        required
        {...rest}
      />
      <label>{label || placeholder}</label>
      {button && (
        <span
          className={`${styles.inputButton} ${button.icon}`}
          onClick={button.onClick}
        ></span>
      )}
    </div>
  )
}

export default TextInput
